import { Factory } from '../../services/Factory';

namespace app.directives.controls {
  import IAugmentedJQuery = angular.IAugmentedJQuery;

  export interface ISliderScope extends angular.IScope {
    update: Function;
    ngShow: boolean;
  }

  export interface ISliderAttributes extends angular.IAttributes {
    min: number;
    max: number;
    step: number;
    value: number;
    width: number;
  }

  export class Slider implements angular.IDirective {
    public restrict: string = 'E';
    public link: (scope: ISliderScope, element: IAugmentedJQuery, attrs: ISliderAttributes) => void;
    public template: string;
    public scope = {update: '=callback', ngShow: "="};

    constructor() {
      this.template = "<input type='text'>";
      this.link = (scope: ISliderScope, element: IAugmentedJQuery, attrs: ISliderAttributes) => {
        scope.$watch("ngShow", (visible) => {
          if (visible) {
            // With replace:true gone, element is the <iio-slider> wrapper; the plugin
            // must be initialized on the inner <input> element.
            const input = element.find('input');
            input.attr("data-slider-min", attrs.min || 1)
              .attr("data-slider-max", attrs.max || 100)
              .attr("data-slider-step", attrs.step || 1)
              .attr("data-slider-value", attrs.value || 50)
              .css("width", `${attrs.width || 270}px`);

            let slider = (input as any).bootstrapSlider();

            slider.on("slideStop", (args: any) => scope.update(args.value));
            setTimeout(() => {
              slider.bootstrapSlider("relayout").bootstrapSlider("refresh");
            }, 100);
          }
        });
      };
    }
  }

  frontendApp.directive("iioSlider", [Factory.Create(Slider)]);
}
